import React from "react";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { OnPremiseFulfilmentData } from "@swiggy-private/cart-types";
import { IconName } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb/types";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

import DeliveryDetailsWidget from "../delivery-detail-widget/DeliveryDetailsWidget";
import { TEXTS, ICONS, DELIVERY_DETAILS_IMAGE_SIZE } from "@cart-ui/constants";
import { IHeaderData, IDeliveryRowData, IToolTipData } from "@cart-ui/interfaces";

const CINEMA_CHAIR_HEADER_IMAGE = "portal/static-assets/images/cinepolis/cinema-chair.png";
const HEADER_GRADIENT = "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(208, 0, 66, 0.2) 100%)";

const TOOLTIP_LEFT_ASSET: IToolTipData["leftAsset"] = {
    name: TEXTS.ON_PREMISE_TOOLTIP_LEFT_ASSET_NAME as IconName,
    fillColor: TEXTS.ON_PREMISE_TOOLTIP_LEFT_ASSET_FILL_COLOR as keyof IColors,
    strokeColor: TEXTS.ON_PREMISE_TOOLTIP_LEFT_ASSET_STROKE_COLOR as keyof IColors,
};

const getHeaderData = (data: OnPremiseFulfilmentData): IHeaderData => ({
    title: data.title,
    subtitle: data.subtitle,
    imageUrl: CINEMA_CHAIR_HEADER_IMAGE,
    background: HEADER_GRADIENT,
});

const getContentData = (data: OnPremiseFulfilmentData, ctaAction: VoidFunction): IDeliveryRowData => ({
    icon: (
        <Image
            width={DELIVERY_DETAILS_IMAGE_SIZE.ICON_IMAGE_SIZE}
            height={DELIVERY_DETAILS_IMAGE_SIZE.ICON_IMAGE_SIZE}
            cloudinaryId={ICONS.CINEPOLIS_CHAIR_ICON}
        />
    ),
    title: data.orderTypeTitle || TEXTS.DEFAULT_ORDER_TYPE_LABEL,
    subtitle: data.orderTypeSubtitle,
    ctaLabel: TEXTS.DEFAULT_SELECT_CTA,
    ctaAction,
});

const getContactData = (data: OnPremiseFulfilmentData, ctaAction: VoidFunction): IDeliveryRowData => ({
    icon: (
        <Image
            width={DELIVERY_DETAILS_IMAGE_SIZE.ICON_IMAGE_SIZE}
            height={DELIVERY_DETAILS_IMAGE_SIZE.ICON_IMAGE_SIZE}
            cloudinaryId={ICONS.CINEPOLIS_CALL_ICON}
        />
    ),
    title: TEXTS.DEFAULT_MOBILE_NUMBER_LABEL,
    subtitle: data.mobile_number,
    ctaLabel: TEXTS.DEFAULT_EDIT_CTA,
    ctaAction,
});

const getToolTipData = (text: string, onDismiss: VoidFunction): IToolTipData => ({
    text,
    onDismiss,
    leftAsset: TOOLTIP_LEFT_ASSET,
});

export interface CinemaWidgetProps {
    onPremiseData: OnPremiseFulfilmentData;
    onOrderTypeEditClick: VoidFunction;
    onMobileEditClick: VoidFunction;
    premiseTooltipText?: string | null;
    onDismissPremiseTooltip: VoidFunction;
}

const CinemaWidget: React.FC<CinemaWidgetProps> = ({
    onPremiseData,
    onOrderTypeEditClick,
    onMobileEditClick,
    premiseTooltipText,
    onDismissPremiseTooltip,
}) => (
    <DeliveryDetailsWidget
        headerData={getHeaderData(onPremiseData)}
        deliveryContentData={getContentData(onPremiseData, onOrderTypeEditClick)}
        deliveryContactData={getContactData(onPremiseData, onMobileEditClick)}
        toolTipData={getToolTipData(premiseTooltipText ?? "", onDismissPremiseTooltip)}
    />
);

export default React.memo(CinemaWidget);
